import * as turf from '@turf/turf';
import _ from 'lodash';
import moment from './moment';

// Parse locals data obtained from API
const parseData = (localsToParse = [], statusesToParse = []) => {
  const statuses = {};

  statusesToParse.forEach((status) => {
    statuses[status.NUMERO_LOCAL] = status.ESTADO === '1';
  });

  return localsToParse
    .filter((local) => {
      const coordenada = local.coordenada.trim();
      const regex = new RegExp(/^-?\d+\.\d+,\s?-?\d+\.\d+$/);

      return regex.test(coordenada);
    })
    .map((local) => {
      const [lat, lng] = local.coordenada
        .trim()
        .split(',')
        .map((coordenada) => parseFloat(coordenada, 10));

      const operativoOficial = statuses[parseInt(local.local, 10)];
      const abierto = !!operativoOficial;
      return {
        ...local,
        abierto,
        coordenada: turf.point([lng, lat]),
        coordenadaObj: {
          lat,
          lng,
        },
        is24h: local.lv === 'Urgencia',
      };
    });
};

const getHumanizedDayOfWeek = (day) => {
  if (day == '0') return 'sunday';
  if (day == '6') return 'saturday';
  return 'weekday';
};

const setStatusByFilters = (local, filters) => {
  const time = parseInt(filters.time, 10);
  const humanizedDayOfWeek = getHumanizedDayOfWeek(filters.date);
  const { open, close } = local.openingHours[humanizedDayOfWeek];
  let abierto = local.abierto;

  if (!open && !close) abierto = false;

  // Check opening hours
  if (typeof open === 'number' && typeof close === 'number') {
    if (time < open || time > close) abierto = false;
  }

  return {
    ...local,
    abierto,
  };
};

// Return nearest locals from an specific local with distance between them
const getNearestLocalsFromPoint = (locals, point, kms = 10, n = null, open = false, filters) => {
  const localsInRegionWithDistance = locals
    // Apply open status by filters date and time
    .map((local) => setStatusByFilters(local, filters))
    .filter((local) => {
      // Avoid return same local, and check if returns all or only available stores
      const validation = !turf.booleanEqual(point, local.coordenada);
      if (open) return validation && local.abierto;
      return validation;
    })
    .map((local) => ({
      ...local,
      distanceFromPoint: turf.distance(point, local.coordenada),
    }))
    .filter((local) => local.distanceFromPoint <= kms);

  const sortedLocals = _.sortBy(localsInRegionWithDistance, ['distanceFromPoint']);

  if (!n) return sortedLocals;
  return _.take(sortedLocals, n);
};

// See if should show local by a filter
const shouldShowLocalByFilters = (local, filters) => {
  const { filter } = filters;

  // Check filters
  if (filter === 'open' && !local.abierto) return false;
  if (filter === '24hrs' && !local.is24h) return false;
  // TODO: ask about this one
  // if (filter === 'shift' && !local.abierto) return false;

  return true;
};

// Actual time with steps of 30 mins
const getActualTime = () => {
  const actualDate = new Date();
  const actualHour = actualDate.getHours();
  const actualMinutes = actualDate.getMinutes();
  let actualTime;

  if (actualMinutes >= 30) {
    actualTime = (actualHour + 1) * 100;
  } else {
    actualTime = actualHour * 100 + 30;
  }
  return actualTime.toString();
};

const getDates = (days = 7) => {
  const date = moment();
  const dates = [];

  [...Array(days).keys()].forEach(() => {
    dates.push({
      value: date.day(),
      text: date.format('dddd, D MMMM'),
    });
    date.add(1, 'day');
  });
  return dates;
};

const getToday = () => {
  const today = new Date();
  return  today.getDay()
}

const getTimes = () => {
  const times = [];

  [...Array(24).keys()].forEach((hour) => {
    times.push({
      value: hour * 100,
      text: `${hour}:00`,
    });
    times.push({
      value: hour * 100 + 30,
      text: `${hour}:30`,
    });
  });

  return times;
};

export {
  parseData,
  getNearestLocalsFromPoint,
  shouldShowLocalByFilters,
  setStatusByFilters,
  getActualTime,
  getTimes,
  getDates,
  getToday,
};
